import { useEffect, useState } from 'react';
import { ApiErrorModal } from '@/components/ui/ApiErrorModal';
import { errorBus } from '@/api/errorBus';

/**
 * ApiErrorHandler
 *
 * Listens for generic `api-error` events emitted by the Axios error
 * interceptor and surfaces them via `ApiErrorModal`. This is intentionally
 * separate from `AuthGuard`, which is only responsible for auth/session
 * concerns (401 / token expiry), not global API error display.
 *
 * Mount once near the root of the app (e.g. in `App.tsx`).
 */
export function ApiErrorHandler() {
  const [apiError, setApiError] = useState<{ message: string; status?: number } | null>(null);

  useEffect(() => {
    const unsubApiError = errorBus.on('api-error', (detail) => {
      setApiError(detail);
    });

    return unsubApiError;
  }, []);

  const handleClose = () => setApiError(null);

  return (
    <ApiErrorModal
      open={!!apiError}
      message={apiError?.message ?? ''}
      status={apiError?.status}
      onClose={handleClose}
    />
  );
}
